export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'

export const USER_LOGOUT = 'USER_LOGOUT'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET'

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST'
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS'
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL'
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET'

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST'
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS'
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL'
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET'

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST'
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS'
export const USER_LIST_FAIL = 'USER_LIST_FAIL'
export const USER_LIST_RESET = 'USER_LIST_RESET'

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAIL = 'USER_DELETE_FAIL'

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL'
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET'

export const GET_ALL_USERS_REQUEST = 'GET_ALL_USERS_REQUEST'
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS'
export const GET_ALL_USERS_FAIL = 'GET_ALL_USERS_FAIL'

export const REGISTER_LICENSE_REQUEST = 'REGISTER_LICENSE_REQUEST'
export const REGISTER_LICENSE_SUCCESS = 'REGISTER_LICENSE_SUCCESS'
export const REGISTER_LICENSE_FAIL = 'REGISTER_LICENSE_FAIL'

export const SUBMIT_EXPERIENCE_REQUEST = 'SUBMIT_EXPERIENCE_REQUEST'
export const SUBMIT_EXPERIENCE_SUCCESS = 'SUBMIT_EXPERIENCE_SUCCESS'
export const SUBMIT_EXPERIENCE_FAIL = 'SUBMIT_EXPERIENCE_FAIL'
export const SUBMIT_EXPERIENCE_RESET = 'SUBMIT_EXPERIENCE_RESET'

export const GET_USER_LOCATION_REQUEST = 'GET_USER_LOCATION_REQUEST'
export const GET_USER_LOCATION_SUCCESS = 'GET_USER_LOCATION_SUCCESS'
export const GET_USER_LOCATION_FAIL = 'GET_USER_LOCATION_FAIL'

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST'
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS'
export const USER_RESET_PASSWORD_FAIL = 'USER_RESET_PASSWORD_FAIL'

export const CONFIRM_REGISTRATION_REQUEST = 'CONFIRM_REGISTRATION_REQUEST'
export const CONFIRM_REGISTRATION_SUCCESS = 'CONFIRM_REGISTRATION_SUCCESS'
export const CONFIRM_REGISTRATION_FAIL = 'CONFIRM_REGISTRATION_FAIL'

export const OPEN_CREATE_PCR_DIALOG = 'OPEN_CREATE_PCR_DIALOG'
export const OPEN_CREATE_PCR_DIALOG_RESET = 'OPEN_CREATE_PCR_DIALOG_RESET'
